export const COLOR_CODE = {
  primary : "#4582ec",
  secondary : "#adb5bd",
  success : "#02b875",
  info : "#17a2b8",
  warning : "#f0ad4e",
  danger : "#d9534f",
  light : "#f8f9fa",
  dark : "#212529",
};

export const hexToRgba = (hex, a) => {
  const nakedHex = hex.charAt(0) === "#" ? hex.slice(1) : hex;
  const decimalObject = convertToDecimal(nakedHex);

  return formatRgba(decimalObject, a)
}

const convertToDecimal = (hex) => {
  const isShort = hex.length === 3 || hex.length === 4;

  const decimalR = parseInt((isShort ? `${hex.slice(0, 1)}${hex.slice(0, 1)}` : hex.slice(0, 2)), 16);
  const decimalG = parseInt((isShort ? `${hex.slice(1, 2)}${hex.slice(0, 2)}` : hex.slice(2, 4)), 16);
  const decimalB = parseInt((isShort ? `${hex.slice(2, 3)}${hex.slice(2, 3)}` : hex.slice(4, 6)), 16);
  const decimalA = parseInt(((isShort ? `${hex.slice(3, 4)}${hex.slice(3, 4)}` : hex.slice(6, 8)) || "FF"), 16);

  return {
    r: decimalR,
    g: decimalG,
    b: decimalB,
    a: (decimalA / 255).toFixed(2),
  }
}

const formatRgba = (rgba, paramA) => {
  const a = (!isNaN(parseFloat(paramA)) && isFinite(paramA)) ? paramA : rgba.a;
  return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${a})`;
}
